<template>
  <div class="tcontainer">
    <template v-if="tCol==='0'">
      <div class="box" v-for="(index) in dataRow.dt.length" :key="index" v-if="index>startDisplay" >
        <numberinput v-model="dataRow.dt[index-1]" 
          :disabled="!!dataDisable[index-1]"
          v-zero
          v-bind:class="disClass(!!dataDisable[index-1])"
        >
        </numberinput>
      </div>
      <template v-if="tRow==='1'">
        <input v-model.number="row1" :disabled="true" class="totalBox">
      </template>
    </template>
    <template v-if="tCol==='1'">
      <div class="box" v-for="(index) in dataRow.length" :key="index" v-if="index>startDisplay" >
        <numberinput v-model="dataRow[index-1]" 
          :disabled="!!dataDisable[index-1]"
          class="inputBoxDisable2"
        >
        </numberinput>
      </div>
      <template v-if="tRow==='1'">
        <input v-model.number="row1" :disabled="true" class="totalBox">        
      </template>
    </template>
  </div>
  <!--
  <div class="tcontainer">
    <template v-if="tCol==='0'">
      <div class="box" v-for="(index) in dataRow.dt.length" :key="index" v-if="index>startDisplay" >
        <input v-model.number="dataRow.dt[index-1]" 
          :disabled="!!dataDisable[index-1]"
          v-zero
          @keypress="isNumber($event)" v-bind:class="disClass(!!dataDisable[index-1])"
        >
      </div>
      <template v-if="tRow==='1'">
        <input v-model.number="row1" :disabled="true" class="totalBox">
      </template>
    </template>
    <template v-if="tCol==='1'">
      <div class="box" v-for="(index) in dataRow.length" :key="index" v-if="index>startDisplay" >
        <input v-model.number="dataRow[index-1]" 
          :disabled="!!dataDisable[index-1]"
          @keypress="isNumber($event)" class="inputBoxDisable2">
      </div>
      <template v-if="tRow==='1'">
        <input v-model.number="row1" :disabled="true" class="totalBox">        
      </template>
    </template>
  </div>
  -->  
</template>

<script>

import NumberInput from '@/components/common/NumberInput.vue'
export default {
  props: ['dataRow', 'dataDisable', 'startDisplay', 'tCol', 'tRow'],
  components: {
    'numberinput': NumberInput
  },
  directives: {
    zero: {
      zero2empty: function (el) {
        el.focus()
      }
    }
  },
  computed: {
    row1: function () {
      let s = this.startDisplay
      let d = []
      if (this.tCol === '0') {
        d = this.dataRow.dt
      } else if (this.tCol === '1') {
        d = this.dataRow
      }
      return d.reduce(function (acc, cval, ind, arr) {
        return (ind < s || ind % 2 === 0) ? acc : acc + cval
      }, 0)
    },
    row2: function () {
      let s = this.startDisplay
      let d = []
      if (this.tCol === '0') {
        d = this.dataRow.dt
      } else if (this.tCol === '1') {
        d = this.dataRow
      }
      return d.reduce(function (acc, cval, ind, arr) {
        return (ind < s || ind % 2 === 1) ? acc : acc + cval
      }, 0)
    }
  },
  methods: {
    disClass: function (arg) {
      return arg ? 'inputBoxDisable' : 'inputBox'
    }
  }
}
</script>

<style scoped>
.tcontainer {
  display: flex;
  border:1px solid #000;
  font-size: 16px;
  text-align:center;
  width:360px;
  height:40px;
}
.box {
  border:0.5px solid #000;
  overflow: hidden;
  text-align:center;
  width:60px;
  height:40px;
}
.inputBox {
  border:0px;
  text-align:center;
  font-size: 14px;
  width:60px;
  height:40px;
}
.inputBoxDisable {
  border:0px;
  background: lightgray;
  color: lightgray;
  text-align:center;
  user-select: none;
  width:60px;
  height:40px;
}
.inputBoxDisable2 {
  border:0px solid #000;
  background: lightgray;
  text-align:center;
  width:60px;
  height:40px;
  user-select: none;
}
.totalBox {
  border:0px solid #000;
  background: lightgray;
  text-align:center;
  width:60px;
  height:40px;
}
</style>

